import { render, staticRenderFns } from "./NumberPack.vue?vue&type=template&id=22e9983c"
import script from "./NumberPack.vue?vue&type=script&lang=js"
export * from "./NumberPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports